import log from 'salvo-lite/log'
import { getSizedImageUrl, getPrice } from '../helpers/shopify'
import axios from 'axios'

class CartUpdate {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._data = {
            action: 'add',
            event: 'click',
            product: this._elem.closest('[data-product]'),
            cartSelector: '.slideout-cart',
            cartItemsSelector: '[data-cart-items]',
            cartItemSelector: '.cart-item',
            delay: 0,
            maxQuantity: 1,
            emptyCartClass: 'cart-empty',
            languages: {},
            ...JSON.parse(elem.getAttribute('data-cart-update') || '{}')
        }
        this._cart = document.querySelector(this._data.cartSelector)
        this._cartItems = document.querySelector(this._data.cartItemsSelector)
        log.debug(this.constructor.name, 'Constructed', this)
    }

    onInit () {
        this._elem.addEventListener(this._data.event, e => {
            e.preventDefault()
            setTimeout(() => {
                if (this._data.variantID) {
                    this._variantID = this._data.variantID
                } else if (this._data.product.querySelector('[data-product-selected-variant]')) {
                    this._variantID = parseInt(this._data.product.querySelector('[data-product-selected-variant]').value)
                } else {
                    this._variantID = parseInt(this._data.product.getAttribute('data-product'))
                }
                this[`_${this._data.action}`]()
            }, this._data.delay)
        })
    }

    _add () {
        const quantity = (this._data.product && this._data.product.querySelector('[data-product-quantity]')) ? parseInt(this._data.product.querySelector('[data-product-quantity]').value) : 1

        // if user hasnt selected size, open size dropdown
        if (this._data.product.querySelector('[data-product-selected-variant]').value === 'null') {
            this._data.product.querySelector('.product__variants > div').click()
            return false
        }

        // check if product is already in cart
        axios.get('/cart.js').then(response => {
            let alreadyExists = false
            const items = response.data.items
            items.forEach(item => {
                if (item.variant_id === this._variantID) alreadyExists = true
            })

            axios.post('/cart/add.js', {
                quantity: quantity,
                id: this._variantID
            }).then(response => {
                log.debug(this._name, 'added to cart', response)
                alreadyExists ? this._updateItem() : this._addNewCartItem(response.data)
                this._updateCartTotal()
                this._updateCartCount()
                this._successMessage()
                window.innerWidth > 600 ? this._openCart() : this._successMessage()
            }).catch(error => {
                console.error(error)
            })
        })
    }

    _addNewCartItem (product) {
        log.debug(this._name, 'Added cart item', product)

        const newCartItem = this._createNewCartItemHTML(product)

        this._cartItems.appendChild(newCartItem)

        this._cart.classList.contains(this._data.emptyCartClass) && this._cart.classList.remove(this._data.emptyCartClass)

        this._theme.registerComponents(newCartItem)
    }

    _createNewCartItemHTML (product) {
        const newCartItem = document.createElement('div')
        newCartItem.classList.add('cart-item')
        newCartItem.setAttribute('data-product', product.id)

        // Image
        const imageSrc = getSizedImageUrl(product.image, '220x296')
        const imageWrapper = document.createElement('a')
        imageWrapper.classList.add('cart-item__image', 'object-cover')
        const image = document.createElement('img')
        image.src = imageSrc
        imageWrapper.appendChild(image)
        newCartItem.appendChild(imageWrapper)

        // right side - information & data
        const information = document.createElement('div')
        information.classList.add('cart-item__information')

        // column 1
        const column1 = document.createElement('div')
        column1.classList.add('cart-item__column')

        const title = document.createElement('h3')
        title.classList.add('cart-item__title')
        title.innerHTML = product.product_title

        const remove = document.createElement('button')
        remove.classList.add('cart-item__remove')
        remove.setAttribute('data-cart-update', `{"action": "remove", "variantID": ${product.id}}`)
        remove.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17"><g><g><g><g><path d="M15.994 8.532c0 4.16-3.349 7.518-7.497 7.518S1 12.692 1 8.532 4.35 1.013 8.497 1.013s7.497 3.358 7.497 7.519zm1 0C16.994 3.82 13.195.01 8.497.01S0 3.82 0 8.532s3.799 8.522 8.497 8.522 8.497-3.81 8.497-8.522z"/></g><g><path d="M12.137 4.18l.707.71-7.987 8.01-.707-.709z"/></g><g><path d="M4.857 4.18l7.987 8.01-.707.71L4.15 4.89z"/></g></g><g/></g></g></svg>'

        title.appendChild(remove)
        column1.appendChild(title)

        // options
        const options = document.createElement('ul')
        options.classList.add('cart-item__options')
        product.options_with_values.forEach(option => {
            const listItem = document.createElement('li')
            listItem.innerHTML = `${option.name.replace('Title', 'Size')}: <span class="cart-item__option-value">${option.value}</span>`
            options.appendChild(listItem)
        })

        column1.appendChild(options)
        information.appendChild(column1)

        // column 2
        const column2 = document.createElement('div')
        column2.classList.add('cart-item__column')

        // quantity
        const quantity = document.createElement('select')
        quantity.setAttribute('data-select', '{ "classNames": { "containerOuter": "box box--sm choices cart-item__quantity" } }')
        quantity.setAttribute('data-cart-update', '{ "action": "updateQuantity", "event": "change" }')
        for (var i = 0; i < 20; i++) {
            const option = document.createElement('option')
            option.value = i
            option.textContent = i
            if (i === product.quantity) option.selected = true
            quantity.appendChild(option)
        }

        column2.appendChild(quantity)
        information.appendChild(column2)

        // column 3
        const column3 = document.createElement('div')
        column3.classList.add('cart-item__column')

        // price
        const price = document.createElement('span')
        price.classList.add('cart-item__price')
        price.innerHTML = `<p class="product-price cart-item__price">${getPrice(product.price)}</p>`

        column3.appendChild(price)
        information.appendChild(column3)

        newCartItem.appendChild(information)

        return newCartItem
    }

    _remove () {
        axios.post('/cart/update.js', {
            updates: {
                [this._variantID]: 0
            }
        }).then(response => {
            this._updateCartTotal()
            this._removeCartItem()
            this._updateCartCount()
            if (response.data.item_count === 0) setTimeout(() => this._cart.classList.add(this._data.emptyCartClass), 600)
        }).catch(error => {
            console.error(error)
        })
    }

    _removeCartItem () {
        const cartItem = this._elem.closest(this._data.cartItemSelector)
        cartItem.style.height = cartItem.offsetHeight + 'px'
        setTimeout(() => cartItem.classList.add(`${this._data.cartItemSelector}--remove`), 200)
        setTimeout(() => cartItem.remove(), 500)
    }

    _updateQuantity () {
        const quantity = parseInt(this._elem.value) || parseInt(this._data.product.querySelector('[data-product-quantity]').value)
        axios.post('/cart/update.js', {
            updates: {
                [this._variantID]: quantity
            }
        }).then(response => {
            log.debug(this._name, 'success', response)
            this._updateCartTotal()
            this._updateCartCount()
            if (quantity <= 0) this._removeCartItem()
        }).catch(error => {
            console.error(error)
        })
    }

    // _updateVariant () {
    //     const newVariantID = parseInt(this._elem.value)
    //     const quantity = parseInt(this._data.product.querySelector('[data-product-quantity]').value) || 1
    //     axios.post('/cart/update.js', {
    //         updates: {
    //             [this._variantID]: 0
    //         }
    //     }).then(response => {
    //         axios.post('/cart/update.js', {
    //             updates: {
    //                 [newVariantID]: quantity
    //             }
    //         }).then(response => {
    //             log.debug('success', response)
    //             this._updateCartTotal()
    //             this._updateItem(response.data, newVariantID)
    //         }).catch(error => {
    //             console.error(error)
    //         })
    //     }).catch(error => {
    //         console.error(error)
    //     })
    // }

    _updateItem () {
        const cartItem = this._cart.querySelector(`[data-product="${this._variantID}"]`)
        const cartItemInformation = cartItem.querySelector('.cart-item__information')

        axios.get('/cart').then(response => {
            // update page contents
            const updatedPage = document.createElement('div')
            updatedPage.innerHTML = response.data
            const matchingItemInformation = updatedPage.querySelector(`[data-product="${this._variantID}"] .cart-item__information`)
            cartItemInformation.innerHTML = matchingItemInformation.innerHTML

            // re-initialize components
            this._theme.registerComponents(cartItem)
        })
    }

    _updateCartTotal () {
        axios.get('/cart.js').then((response) => {
            const cartTotalElems = document.querySelectorAll('[data-cart-total]')
            cartTotalElems.forEach(elem => {
                elem.textContent = getPrice(response.data.total_price, response.data.currency)
            })
        })
    }

    _updateCartCount (cart) {
        axios.get('/cart.js').then((response) => {
            const cartItemCount = response.data.item_count
            const cartIcons = document.querySelectorAll('[data-cart-count]')
            const cartIconsAttr = document.querySelectorAll('[data-cart-count-attr]')
            cartIcons.forEach(cartCountElem => {
                cartCountElem.textContent = cartItemCount
            })
            cartIconsAttr.forEach(cartCountAttrElem => {
                cartCountAttrElem.setAttribute('data-cart-count-attr', cartItemCount)
            })
            if (cartItemCount > 0) {
                this._cart.classList.contains('cart-empty') && this._cart.classList.remove('cart-empty')
            } else {
                !this._cart.classList.contains(this._data.emptyCartClass) && this._cart.classList.add(this._data.emptyCartClass)
            }
        })
    }

    _openCart () {
        !document.body.classList.contains('cart-open') && document.body.classList.add('cart-open')
        !this._cart.parentNode.classList.contains('infront') && this._cart.parentNode.classList.add('infront')
    }

    _closeCart () {
        document.body.classList.contains('cart-open') && document.body.classList.remove('cart-open')
        setTimeout(() => this._cart.parentNode.classList.contains('infront') && this._cart.parentNode.classList.remove('infront'), 600)
    }

    // _updateCartItemQuantity () {
    //     // update value
    //     this._cart.querySelector(`[data-product="${this._variantID}"] [data-product-quantity]`).value = parseInt(this._cart.querySelector(`[data-product="${this._variantID}"] [data-product-quantity]`).value) + 1
    //
    //     // update choices ui
    //     this._cart.querySelector(`[data-product="${this._variantID}"]`).querySelector('.choices__item--selectable').textContent = parseInt(this._cart.querySelector(`[data-product="${this._variantID}"]`).querySelector('.choices__item--selectable').textContent) + 1
    // }

    _successMessage () {
        document.body.classList.add('cart-item-added')
        setTimeout(() => document.body.classList.remove('cart-item-added'), 5000)
    }
}

export default CartUpdate



// WEBPACK FOOTER //
// ./src/resources/scripts/components/CartUpdate.js